import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {TaskDashboardData} from '../../../api';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {
  faCalendarDays,
  faCircle,
  faCircleCheck,
  faCircleHalfStroke,
  faListCheck,
  faMoonFull
} from '@fortawesome/pro-solid-svg-icons';
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';
import {DatePipe, NgClass} from '@angular/common';
import {SkeletonLoadingDirective} from '../../../directives/skeleton-loading.directive';
import {EmptyStateComponent} from '../../util/design/empty-state/empty-state.component';

@Component({
  selector: 'app-dashboard-tasks',
  templateUrl: './dashboard-tasks.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, DatePipe, NgClass, SkeletonLoadingDirective, TooltipDirective, EmptyStateComponent]
})
export class DashboardTasksComponent {

  @Input() basicTasks: number[] = [0, 0, 0, 0];
  @Input() allTasks: TaskDashboardData[] = [];
  @Input() loading = false;

  protected readonly faCalendarDays = faCalendarDays;
  protected readonly faListCheck = faListCheck;
  protected readonly faCircle = faCircle;
  protected readonly faMoonFull = faMoonFull;
  protected readonly faCircleCheck = faCircleCheck;
  protected readonly faCircleHalfStroke = faCircleHalfStroke;


  get open(): number {
    return this.basicTasks[0];
  }

  get inProgress(): number {
    return this.basicTasks[1];
  }

  get done(): number {
    return this.basicTasks[2];
  }

  get verified(): number {
    return this.basicTasks[3];
  }

  get total(): number {
    return this.basicTasks.reduce((a, b) => a + b, 0);
  }

  get hasTasks(): boolean {
    return this.total > 0;
  }

  get myTasks(): TaskDashboardData[] {
    return this.allTasks;
  }

  isOverdue(dueDate: Date | undefined): boolean {
    if (!dueDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);
    return due < today;
  }
}
